import axios from "axios";
import axiosTokenService from "./axiosTokenService";
import {   final_url } from "./Configuration";
import moment from "moment-timezone";
import axiosWithOutToken from "../Components/axiosWithOutToken";

const cloud_url = "https://api.dev.herb.apcfss.in/dms/user-defined-path/";
class DesService {
  loginDetails(params) {
    return axiosWithOutToken.post(final_url + "userLogin", params);
  }
  getLoginData(params) {
    return axiosTokenService.post(final_url + "userLogin", params)
  }
  getEntryFormList(params) {
    return axiosTokenService.post(final_url + "userserviceslist", params)
  }
  userLogout(params) {
    return axiosTokenService.post(final_url + "LogOut", params)
  }

  getModuleData(params) {
    return axiosTokenService.post( final_url + "modulelogin", params)

  }
  getCaptcha() {
    return axios.get(final_url + "api/captcha")
  }


  getswitch(params) {
    return axiosTokenService.post(final_url + "switchModule", params)
  }

  
getNotifications(params) {
    return axiosTokenService.post(final_url + "notificationList", params);
  }
}
export default new DesService();
